import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto } from '../../../../service/dto';

@Component({
    selector: 'app-suspended',
    templateUrl: './suspended.component.html',
    styleUrl: './suspended.component.scss',
    standalone: false
})
export class SuspendedComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();

}
